import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { CreateParticipantInput, Participant } from '@nx/domain';
import { asyncStatusReducers, initialAsyncStatus } from './asyncStatus';

const participantsSlice = createSlice({
  name: 'participants',
  initialState: {
    items: [] as Participant[],
    ...initialAsyncStatus,
  },
  reducers: {
    participantsWatchRequested(_state, _action: PayloadAction<string>) {},
    participantsLoaded(state, action: PayloadAction<Participant[]>) {
      state.items = action.payload;
      asyncStatusReducers.resolveLoaded(state);
    },
    participantCreateRequested(
      state,
      _action: PayloadAction<{ eventId: string; input: CreateParticipantInput }>,
    ) {
      asyncStatusReducers.markSaving(state);
    },
    participantUpdateRequested(
      state,
      _action: PayloadAction<{
        eventId: string;
        participantId: string;
        input: Partial<CreateParticipantInput> & { checkedIn?: boolean };
      }>,
    ) {
      asyncStatusReducers.markSaving(state);
    },
    participantImportRequested(
      _state,
      _action: PayloadAction<{ eventId: string; inputs: CreateParticipantInput[] }>,
    ) {},
    participantCheckInRequested(
      _state,
      _action: PayloadAction<{ eventId: string; participantId: string }>,
    ) {},
    participantsSaveSucceeded(state) {
      asyncStatusReducers.resolveSaveSucceeded(state);
    },
    participantsFailed: asyncStatusReducers.resolveFailed,
  },
});

export const {
  participantsWatchRequested,
  participantsLoaded,
  participantCreateRequested,
  participantUpdateRequested,
  participantImportRequested,
  participantCheckInRequested,
  participantsSaveSucceeded,
  participantsFailed,
} = participantsSlice.actions;

export default participantsSlice.reducer;
